import { atom } from 'jotai';

export const isSavingModalOpenAtom = atom(false);
